import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFavouriteMealPlans, chooseFavouriteMealPlan, editFavouriteMealPlan, deleteFavouriteMealPlan, clearMessage } from '../../../redux/slices/customer/mealPlanSlice';
import Back from '../../../components/common/Back';

const FavouriteMealPlans = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [newTitle, setNewTitle] = useState("");
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const { mealPlans, errorMessage } = useSelector((state) => state.mealPlan);

  useEffect(() => {
      dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    dispatch(fetchFavouriteMealPlans());
  }, [dispatch]);

  const handleChooseClick = async (planId) => {
    await dispatch(chooseFavouriteMealPlan(planId));
    dispatch(fetchFavouriteMealPlans());
  };

  const handleEditClick = (plan) => {
    setCurrentPlan(plan);
    setNewTitle(plan.title);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setCurrentPlan(null);
  };

  const handleUpdate = async () => {
    await dispatch(editFavouriteMealPlan({ planId: currentPlan.id, title: newTitle }));
    setModalOpen(false);
    dispatch(fetchFavouriteMealPlans()); // Refresh list after update
  };

  const handleDeleteClick = (planId) => {
    setPlanToDelete(planId);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteFavouriteMealPlan(planToDelete));
    setDeleteModalOpen(false);
    setPlanToDelete(null);
    dispatch(fetchFavouriteMealPlans()); // Refresh list after deletion
  };

  const cancelDelete = () => {
    setDeleteModalOpen(false);
    setPlanToDelete(null);
  };

  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Favourite Meal Plans</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </header>
          <div className="page-subheading pb-3">
            <h4>Select from the meal plan you saved as favourite:</h4>
          </div>
          <div className="main-content flex justify-between flex-col-rev-mob">
            <div className="phases-container">
              <div className="card responsive-table-container p-0">
                <table className="admin-table current-ingredients-table">
                  <thead>
                    <tr>
                      <th>Plan Name</th>
                      <th>Creation Date</th>
                      <th>Choose</th>
                      <th>Edit</th>
                      <th>Delete</th> {/* Added Delete Column */}
                    </tr>
                  </thead>
                  <tbody>
                    {errorMessage ? (
                      <tr>
                        <td colSpan="5">Error: {errorMessage}</td>
                      </tr>
                    ) : (
                      mealPlans.map((plan) => (
                        <tr key={plan.id}>
                          <td>{plan.title}</td>
                          <td>{new Date(plan.creation_date).toLocaleString()}</td>
                          <td>
                            <button
                              className={`btn-choose ${plan.is_active ? 'active' : ''}`}
                              style={{
                                backgroundColor: plan.is_active ? 'green' : '#de2c2f',
                                color: 'white',
                              }}
                              onClick={() => handleChooseClick(plan.id)}
                            >
                              {plan.is_active ? 'Active' : 'Choose'}
                            </button>
                          </td>
                          <td>
                             <a className="edit_icon icon-edit" onClick={() => handleEditClick(plan)}>
                              <i className="bi bi-pencil-square"></i>
                            </a>
                          </td>
                          <td>
                            <a className="icon-trash" href="javascript:void(0)" onClick={() => handleDeleteClick(plan.id)}>
                              <i className="bi bi-trash3 cursor-pointer ms-2"></i>
                            </a>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for editing meal plan */}
        {isModalOpen && (
          <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header justify-content-center">
                  <h5 className="modal-title">Edit Meal Plan Name</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={handleModalClose}></button>
                </div>
                <div className="modal-body px-md-5 pb-md-4">
                  <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}>
                    <div className="row g-3 gx-md-5 gy-md-4">
                      <div className="col-md-12">
                        <input
                          type="text"
                          required
                          className="form-control form-control-lg"
                          value={newTitle}
                          onChange={(e) => setNewTitle(e.target.value)}
                        />
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="btn btn-create w-100">Update</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {isDeleteModalOpen && (
          <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header justify-content-center">
                  <h5 className="modal-title">Confirm Deletion</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={cancelDelete}></button>
                </div>
                <div className="modal-body text-center">
                  <p>Are you sure you want to delete this meal plan?</p>
                  <button className="btn btn-danger" onClick={confirmDelete}>Yes, Delete</button>
                  <button className="btn btn-secondary ms-2" onClick={cancelDelete}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </Layout>
  );
};

export default FavouriteMealPlans;